// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87e2bb59","455":"7816673f","977":"54cf577c"}[chunkId] + ".chunk.js";
};